import { FluxType } from 'flux/buildFlux';
import { AuthenticationInfo } from './model/AuthenticationInfo';
import { buildContext, Context } from './aggregates';
import init from './init';
import { AuthenticationAggregate } from './aggregates/authentication/index';
import CordovaServices from './cordova';
import { Observable } from 'rxjs';
import { WlWindow } from 'typings/globals/cordova';
import isEqual from 'lodash.isequal';
import RateAppManager from './services/RateAppManager';
import { InitialAuthState } from 'aggregates/authentication/queries';

declare const window: WlWindow;

export const authentication = new AuthenticationAggregate();
export const flux: FluxType = init();

export const authInfo$ = authentication.queries.authInfo$
  .startWith(InitialAuthState)
  .map(s => s.authInfo ? s.authInfo : null)
  .distinctUntilChanged(isEqual)
  .do(id => console.debug('authInfo$', id))
  .shareReplay(1);

export const aggregates$: Observable<Context> = authentication.queries.authInfo$
  .filter(s => !s.loading && s.authInfo && !!s.authInfo.accountId)
  .map(({ authInfo }) => authInfo)
  .distinctUntilChanged(isEqual)
  .scan((previous: Context, authInfo: AuthenticationInfo) => {
    if (previous) {
      previous.unsubscribe();
    }
    return buildContext(authInfo);
  }, null)
  .filter(x => !!x)
  .do(s => console.debug('aggregates$', s))
  .shareReplay(1);

export const appServices = CordovaServices(flux, authentication, aggregates$);

export const account$ = aggregates$.switchMap(({ accountAggregate }) => accountAggregate.queries.account$);

export const realAccount$ = aggregates$.switchMap(({ accountAggregate }) => accountAggregate.queries.realAccount$);

let storage = null;
try {
  storage = window.localStorage;
} catch(e) { }

export const rateAppManager = new RateAppManager(storage);
